import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { delay, map } from 'rxjs/operators';
import * as NotificationActions from '../actions/notification.action';
export class NotificationEffects {
    constructor(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.createThenRemoveNotification$ = this.actions$.pipe(ofType(NotificationActions.CREATE_NOTIFICATION), delay(3000), map(action => {
            return new NotificationActions.RemoveNotification();
        }));
    }
}
tslib_1.__decorate([
    Effect(),
    tslib_1.__metadata("design:type", Object)
], NotificationEffects.prototype, "createThenRemoveNotification$", void 0);
